import Header from "../components/dashboard/header";
import PageHeader from "./Header";
import Footer from "../components/dashboard/footer";
// import Sidebar from "../components/dashboard/sidebar";
import SubscriptionPayment from "../components/SubscriptionPayment";
import { useNavigate } from "react-router-dom";

const Subscription = () => {

    const token = localStorage.getItem("token");
    const navigate = useNavigate();
    const handlecancel = () => {
        if (localStorage.getItem("moduleid")) {
            navigate('/moduleslibrary')
            localStorage.removeItem("selectedCost");
            localStorage.removeItem("moduleid");
        } else {
            navigate('/lecture-library')
        }




    }

    return (
        <>

            {token ? <Header /> : <PageHeader />}

            {/* <Sidebar /> */}

            <div className="main-content user-management subscription-page" id="main-content">
                <div className="page-content" id="page-content">
                    <div className="container-fluid d-flex justify-content-end pe-0 me-0 pb-2" id="container-fluid">
                        <button className="create-quiz-btn border-0" onClick={handlecancel}>Cancel</button>
                    </div>
                    <div className="row table-data" id="table-data-row">
                        <div className="col-12">
                            <div className="card" id="card">
                                <div className="card-body" id="card-body">
                                    <SubscriptionPayment className="ps-2 pe-2"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div></div>
            <Footer />
        </>
    );
};

export default Subscription;
